<template>
    <h1 class="title">О нас</h1>
</template>

<script>
export default {
    name: "AboutComp"
}
</script>